module.exports = __webpack_public_path__ + "img/89.f08ec887.jpg";